import moment from 'moment';

export function date(value: string, arg: string): string | undefined {
    if (!value) return '';

    return moment(value)
        .locale('es')
        .format(arg);
}
